
<h2 class="page-heading">Blacklist</h2>
<br>
<app-response-text
    [lambdaMessage]="lambdaMessage"
    [lambdaError]="lambdaError">
</app-response-text>




<div class="table-container">

    <app-mat-data-grid
        [header]="header"
        [(dataSource)]="data"
        [formValid]="formValid"
        [displayedColumns]="['LOB', 'phoneNumber', 'count', 'lastCalledDate', 'dateAdded', 'comments']"
        [columnNames]="['LOB', 'Phone #', 'Count', 'Last Called Date', 'Date Added', 'Comments']"
        [editDefinition]="{
            'LOB': lobTemplate,
            'phoneNumber': phoneNumberTemplate,
            'comments': commentsTemplate
        }"
        [pageSizeOptions] = "[5, 10, 15]"
        [buttonConfig]="{create: {show: true}}"
        [objectBluePrint]="bluePrint"
        (buttonClick)="handleButtonClick($event)"
    >
    </app-mat-data-grid>
</div>

<ng-template #header>
    <span>Calls from these phone numbers will be blocked from reaching any customer service agent.</span>
</ng-template>

<ng-template #lobTemplate let-element>
    <select [(ngModel)]="element.LOB" (ngModelChange)="formValid = cleanAndValidate(element)">
        <option *ngFor = "let lob of lobs" [ngValue]="lob">{{lob}}</option>
    </select>
</ng-template>

<ng-template #phoneNumberTemplate let-element>
    <input type="text" [(ngModel)]="element.phoneNumber" [disabled]="!newRow" (ngModelChange)="formValid = cleanAndValidate(element)">
</ng-template>

<ng-template #commentsTemplate let-element>
    <textarea [(ngModel)]="element.comments" placeholder="..." (ngModelChange)="formValid = cleanAndValidate(element)"></textarea>
</ng-template>